import React, { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';

interface PlaidLinkLauncherProps {
    token: string;
    onSuccess: (public_token: string, metadata: any) => void;
    onExit: () => void;
    onError?: (error: any) => void;
}

const PlaidLinkLauncher: React.FC<PlaidLinkLauncherProps> = ({ token, onSuccess, onExit, onError }) => {
    const { open, ready, error } = usePlaidLink({
        token,
        onSuccess,
        onExit,
    });

    useEffect(() => {
        if (ready) {
            open();
        }
    }, [ready, open]);

    useEffect(() => {
        if (error) {
            console.error('[PlaidLinkLauncher] Plaid Link script error', error);
            if (onError) onError(error);
            onExit();
        }
    }, [error, onExit, onError]);

    // Fallback: If Plaid Link fails to initialize within 10s (e.g. ad blocker, network offline), exit cleanly
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (!ready) {
                console.warn('[PlaidLinkLauncher] Plaid Link script load timed out');
                if (onError) onError(new Error('Plaid script timed out'));
                onExit();
            }
        }, 10000);

        return () => clearTimeout(timeoutId);
    }, [ready, onExit, onError]);

    return null;
};

export default PlaidLinkLauncher;
